<template>
    <div>
        <!--  onselectstart="return false;"禁止复制功能 -->
        <app-header></app-header>
        <div class="mb-150"></div>
        <div class="mb-7 app-card w-85">
            <v-container fluid grid-list-xl>
                <v-layout row wrap align-center justify-center>
                    <v-flex xs12 md12 lg7 sm12 class="col-height-auto">
                        <div v-show="isShowMicroArticleLoading" class="mt-7 text-center">
                            <v-progress-circular indeterminate color="aquamarine"></v-progress-circular>
                        </div>
                        <div v-show="!isShowMicroArticleLoading" class="mt-7 app-card">
                            <div class="pa-5 display-1">
                                <v-avatar class="pointer" size="60" @click="goUserData(microArticle.userName)">
                                    <img :src="microArticle.image">
                                </v-avatar>
                                <span class="ml-3 font-lg pointer hover-color" @click="goUserData(microArticle.userName)">{{microArticle.nickName}}</span>
                                <span class="ml-3 font-lg">{{ dateFormat(microArticle.time)}}</span>
                                <div class="mt-3  font-md">
                                    {{microArticle.content}}
                                </div>
                                <div class="mt-3 font-sm right">
                                    <v-icon :class="{'aquamarine--text':isUpvote}" small :title="$t('posting.upvote')" @click="voteMicroArticle(microArticle, '0')">thumb_up</v-icon>
                                        {{microArticle.upvoteCount}}
                                    <!-- <v-icon small :title="$t('postingsel.tread')" class="ml-3" @click="">thumb_down</v-icon>
                                        {{microArticle.downvoteCount}} -->
                                    <v-icon small :title="$t('posting.comment')" class="ml-3" @click="showCommentForm">fa fa-comment</v-icon>
                                        {{microArticle.commentCount}}
                                </div>
                            </div>
                            <v-layout v-show="isShowCommentForm" row wrap justify-center mt-5>
                                <v-flex xs2 md1 lg1 sm1>
                                    <v-avatar class="pointer" size="38" @click="goUserData(loginUserName)">
                                        <img class="img-responsive rounded-circle user-img" :alt="loginUserName" :src="this.$store.state.user.image">
                                    </v-avatar>
                                </v-flex>
                                <v-flex xs9 md10 lg10 sm10>
                                    <v-form ref="commentForm" v-model="commentVaild">
                                        <v-textarea
                                            color="aquamarine"
                                            v-model="commentForm.content"
                                            :rules="commentContentRules"
                                            auto-grow required outline>
                                        </v-textarea>
                                        <div class="right">
                                            <v-btn small dark 
                                                color="aquamarine" 
                                                :disabled="!commentVaild" 
                                                :loading="submitBtnLoading" 
                                                @click="commentMicroArticle">
                                                {{$t("common.submit")}}
                                            </v-btn>
                                            <v-btn small dark 
                                                color="aquamarine" 
                                                @click="isShowCommentForm = !isShowCommentForm">
                                                {{$t("common.cancel")}}
                                            </v-btn>
                                        </div>
                                    </v-form>
                                </v-flex>
                            </v-layout>
                            <v-divider class="mb-5 mt-5"></v-divider>
                            <div v-show="isShowCommentLoading" class="text-center">
                                <v-progress-circular indeterminate color="aquamarine" class="mb-5"></v-progress-circular>
                            </div>
                            <div v-show="!isShowCommentLoading" class="mb-5 ml-4 mr-4 display-1">
                                <div v-show="commentList.length <= 0" class="font-1x text-center">
                                    {{$t("microArticle.no")}}
                                    <a @click="showCommentForm">
                                        {{$t("microArticle.comments")}}
                                    </a>
                                    {{$t("microArticle.yet")}}
                                </div>
                                <h2 v-show="commentList.length > 0">{{$t("microArticle.comments")}}</h2>
                                <div class="mt-5">
                                    <!-- - - - - - - - - - - - - - 一级评论- - - - - - - - - - - - - -->
                                    <template v-for="(comment, index) in commentList">
                                        <div class="font-1x">
                                            <v-avatar class="pointer" size="24" @click="goUserData(comment.userName)">
                                                <img :src="comment.image">
                                            </v-avatar>
                                            <span class="ml-1 pointer hover-color" @click="goUserData(comment.userName)">{{comment.nickName}}</span>
                                            <span class="fw-bold">·</span>
                                            <span>{{ dateFormat(comment.time)}}</span>
                                            <div class="ml-5" v-html="comment.content"></div>
                                        </div>
                                        <div class="ml-5 font-1x">
                                            <v-icon small :class="{'aquamarine--text':comment.isUpvote}" :title="$t('posting.upvote')" @click="voteMicroArticleComment(comment, '0')">thumb_up</v-icon>
                                            {{comment.upvoteCount}}
                                            <v-icon small :title="$t('posting.comment')" class="ml-3" @click="showCommentField(comment)">fa fa-comment</v-icon>
                                            <!-- {{comment.commentCount}} -->
                                        </div>
                                        <div v-show="comment.isShowCommentField" class="ml-5">
                                            <v-textarea
                                                color="aquamarine"
                                                v-model="commentContent"
                                                :rules="commentContentRules"
                                                auto-grow required outline>
                                            </v-textarea>
                                            <v-btn dark color="aquamarine" 
                                                :loading="submitBtnLoading" 
                                                @click="commentRootComment(comment)">
                                                {{$t("common.submit")}}
                                            </v-btn>
                                            <v-btn dark color="aquamarine" 
                                                @click="showCommentField(comment)">
                                                {{$t("common.cancel")}}
                                            </v-btn>
                                        </div>
                                        <!-- - - - - - - - - - - - - - 二级评论- - - - - - - - - - - - - -->
                                        <template v-for="(secondComment, index) in comment.secondCommentInfoList">
                                            <div class="font-1x ml-5">
                                                <v-avatar class="pointer" size="24" @click="goUserData(secondComment.userName)">
                                                    <img :src="secondComment.image">
                                                </v-avatar>
                                                <span class="ml-1 pointer hover-color" @click="goUserData(secondComment.userName)">{{secondComment.nickName}}</span>
                                                <span class="fw-bold">·</span>
                                                <span>{{ dateFormat(secondComment.time)}}</span>
                                                <div class="ml-5" v-html="secondComment.content"></div>
                                                <div class="ml-5">
                                                    <v-icon small :class="{'aquamarine--text':secondComment.isUpvote}" :title="$t('posting.upvote')" @click="voteMicroArticleComment(secondComment, '0')">thumb_up</v-icon>
                                                    {{secondComment.upvoteCount}}
                                                    <v-icon small :title="$t('posting.comment')" class="ml-3" @click="showCommentField(secondComment)">fa fa-comment</v-icon>
                                                    <!-- {{secondComment.commentCount}} -->
                                                </div>
                                            </div>
                                            <div v-show="secondComment.isShowCommentField" class="ml-5 pl-5">
                                                <v-textarea
                                                    color="aquamarine"
                                                    v-model="commentContent"
                                                    :rules="commentContentRules"
                                                    auto-grow required outline>
                                                </v-textarea>
                                                <v-btn dark color="aquamarine" 
                                                    :loading="submitBtnLoading" 
                                                    @click="commentSecondComment(comment, secondComment)">
                                                    {{$t("common.submit")}}
                                                </v-btn>
                                                <v-btn dark color="aquamarine" 
                                                    @click="showCommentField(secondComment)">
                                                    {{$t("common.cancel")}}
                                                </v-btn>
                                            </div>
                                        </template>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </v-flex>
                </v-layout>
            </v-container>
        </div>
    </div>
</template>
<style>

</style>
<script>
    import Vue from 'vue'
    import config from '../../config.js'
    export default {
        data(){
            return{
                userName: this.$route.params.userName,              // 该微文用户的ID
                microArticleId: this.$route.params.microArticleId,  // 该微文的ID
                microArticle: {},                                   // 微文对象
                loginUserName: this.$store.state.user.name,         // 登录的用户名
                loginImage: this.$store.state.user.image,           // 登录的用户头像
                commentVaild: true,                                 // 评论表单验证
                commentForm: {                                      // 评论表单对象
                    microArticleId: null,
                    userId: this.$store.state.user.id,
                    parentCommentId: null,
                    content: ''
                },
                commentContentRules: [                              // 评论内容规则
                    v => !!v || '',
                    v => (v && v.length <= 500) || this.$t("microArticle.commentLimit")
                ],
                voteForm: {                                         // 投票微文的对象
                    microArticleId: null,
                    userId: null,
                    status: null
                },
                commentVoteForm: {                                  // 投票微文评论的对象
                    commentId: null,
                    userId: null,
                    status: null
                },
                isShowCommentForm: false,                           // 是否显示评论表单
                isShowMicroArticleLoading: true,                    // 是否显示微文加载中
                isShowCommentLoading: true,                         // 是否显示评论加载
                submitBtnLoading: false,                            // 提交评论按钮加载中
                commentList: [],                                    // 评论集合
                commentIds: [],                                     // 所有评论主键的集合
                microArticleIds: [],                                // 微文主键集合
                isUpvote: false,                                    // 该用户是否投票
                commentContent: '',                                 // 评论内容
            }
        },
        created(){
            
        },
        mounted(){
            this.getMicroArticle();
        },
        watch:{
            $route(){
                if (this.$route.params.userName) {
                    if (this.$route.params.userName.indexOf('@') == 0) {
                        this.userName = this.$route.params.userName.substring(1);
                    } else {
                        this.userName = this.$route.params.userName;
                    }
                }
                if (this.$route.params.microArticleId) {
                    this.microArticleId = this.$route.params.microArticleId;
                }
            },
            microArticleId() {
                if (this.microArticleId) {
                  // 查询数据
                  this.commentList = [];
                  this.isShowCommentLoading = true;
                  this.getMicroArticle();
                }
            },
        },
        methods: {
            getMicroArticle(){
                if (this.microArticleId == null || this.microArticleId == '') {
                    return;
                }
                this.isShowMicroArticleLoading = true;
                let url = config.baseUrl + "microArticle/open/getMicroArticleInfo?microArticleId=" + this.microArticleId;
                this.$http.get(url).then(response => {
                    let data = response.data;
                    if (data.resCode == 0) {
                        this.microArticle = data.result;
                        this.isShowMicroArticleLoading = false;
                        if (localStorage.getItem('token')) {
                            // 查询投票
                            this.getVoteList();
                        }
                    } else {
                        this.microArticle = {};
                        this.isShowMicroArticleLoading = false;
                        this.$router.push({name: 'page404'});
                    }
                }, error => {
                    this.microArticle = {};
                    this.isShowMicroArticleLoading = false;
                    this.$router.push({name: 'page500'});
                });
                this.getCommentsByMicroArticleId();
            },
            //根据帖子id查询该帖子的评论
            getCommentsByMicroArticleId(){
                let url = config.baseUrl + "microArticleComment/open/getCommentsByMicroArticleId?microArticleId=" + this.microArticleId;
                this.$http.get(url).then(response => {
                    this.isShowCommentLoading = false;
                    let data = response.data;
                    if (data.resCode == 0) {
                        this.commentList = data.result;
                        // 查询评论投票集合
                        if (localStorage.getItem('token')) {
                            this.getCommentVoteList();
                        }
                    } else {
                        this.commentList = [];
                    }
                },error => {
                    this.isShowCommentLoading = false;
                });
            },
            // 查看用户详情页面
            goUserData (username) {
                this.$router.push({
                    name: 'userData',
                    params: {
                        username: '@' + username
                    }
                });
            },
            // 显示登录模态框
            showLoginModal(){
                this.$store.state.loginModal = true;
            },
            // 格式化时间
            dateFormat(time){
                return formatDate(time, this.$i18n.locale);
            },
            // 展示评论框
            showCommentForm(){
                if (!localStorage.getItem('token')) {
                    this.showLoginModal();
                    return;
                }
                this.isShowCommentForm = !this.isShowCommentForm;
            },
            // 评论微文
            commentMicroArticle(){
                if (!localStorage.getItem('token')) {
                    this.showLoginModal();
                    return;
                }
                if (this.$refs.commentForm.validate()) {
                    this.submitBtnLoading = true;
                    this.commentForm.microArticleId = this.microArticleId;
                    this.commentForm.userId = this.$store.state.user.id;
                    let url = config.baseUrl + "microArticleComment/saveComment";
                    this.$http.post(url, this.commentForm).then(response => {
                        this.submitBtnLoading = false;
                        let data = response.data;
                        if (data.resCode == 0) {
                            this.microArticle.commentCount += 1;
                            this.isShowCommentForm = false;
                            this.commentForm.content = '';
                            this.commentList.unshift(data.result);
                        } else {
                            this.submitBtnLoading = false;
                            this.$Message.error(this.$t('common.fail'));
                        }
                    }, error => {
                        this.submitBtnLoading = false;
                        this.$Message.error(this.$t('common.fail'));
                    });
                }
            },
            // 给微文投票
            voteMicroArticle(microArticle, status){
                if (!localStorage.getItem('token')) {
                    this.showLoginModal();
                    return;
                }
                this.voteForm.microArticleId = microArticle.microArticleId;
                this.voteForm.userId = this.$store.state.user.id;
                this.voteForm.status = status;
                let url = config.baseUrl + "microArticle/voteMicroArticle";
                this.$http.post(url, this.voteForm).then(response => {
                    let data = response.data;
                    if (data.resCode == 0) {
                        this.isUpvote = true;
                        microArticle.upvoteCount += 1;
                    } else {
                        this.$Message.warning(this.$t('posting.evaluation'));
                    }
                },error => {
                    this.$Message.error(this.$t('common.fail'));
                });
            },
            // 给微文评论投票
            voteMicroArticleComment(comment, status){
                if (!localStorage.getItem('token')) {
                    this.showLoginModal();
                    return;
                }
                this.commentVoteForm.commentId = comment.commentId;
                this.commentVoteForm.userId = this.$store.state.user.id;
                this.commentVoteForm.status = status;
                let url = config.baseUrl + "microArticleComment/voteMicroArticleComment";
                this.$http.post(url, this.commentVoteForm).then(response => {
                    let data = response.data;
                    if (data.resCode == 0) {
                        comment.isUpvote = true;
                        comment.upvoteCount += 1;
                    } else {
                        this.$Message.warning(this.$t('posting.evaluation'));
                    }
                },error => {
                    this.$Message.error(this.$t('common.fail'));
                });
            },
            // 根据用户主键和微文主键集合查询投票集合
            getVoteList(){
                this.microArticleIds[0] = this.microArticleId;
                let url = config.baseUrl + "microArticle/getVoteList/" + this.$store.state.user.id;
                this.$http.post(url, this.microArticleIds).then(response => {
                    let data = response.data;
                    if (data.resCode == 0) {
                        // 只有一个投票数据
                        if ('0' == data.result[0].status) {
                            this.isUpvote = true;
                        }
                    } else {
                        this.isUpvote = false;
                    }
                });
            },
            // 根据用户主键和微文评论主键集合查询投票集合
            getCommentVoteList(){
                if (this.commentList.length <= 0) {
                    return;
                }
                var count = 0;
                for(let i = 0; i < this.commentList.length; i++){
                    this.commentIds[count] = this.commentList[i].commentId;
                    count++;
                    if (this.commentList[i].secondCommentInfoList) {
                        var secondList = this.commentList[i].secondCommentInfoList;
                        for (let j = 0; j < secondList.length; j++) {
                            this.commentIds[count] = secondList[j].commentId;
                            count++;
                        }
                    }
                }
                let url = config.baseUrl + "microArticleComment/getCommentVoteList/" + this.$store.state.user.id;
                this.$http.post(url, this.commentIds).then(response => {
                    let data = response.data;
                    // 史上最绕最烧脑的评论点赞变色功能
                    if (data.resCode == 0) {
                        for(let i = 0; i < data.result.length; i++){
                            for(let j = 0; j < this.commentList.length; j++){
                                if(data.result[i].commentId == this.commentList[j].commentId){
                                    if ('0' == data.result[i].status) {
                                        this.commentList[j].isUpvote = true;
                                    }
                                } else if (this.commentList[j].secondCommentInfoList != null) {
                                    for(let k = 0; k < this.commentList[j].secondCommentInfoList.length; k++){
                                        if(data.result[i].commentId == this.commentList[j].secondCommentInfoList[k].commentId){
                                            if ('0' == data.result[i].status) {
                                                this.commentList[j].secondCommentInfoList[k].isUpvote = true;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    // 完成后强制渲染页面
                    this.$forceUpdate();
                });
            },
            // 显示/隐藏评论框
            showCommentField(comment){
                if (!localStorage.getItem('token')) {
                    this.showLoginModal();
                    return;
                }
                if (comment.isShowCommentField) {
                    comment.isShowCommentField = false;
                } else {
                    comment.isShowCommentField = true;
                }
                // 完成后强制渲染页面
                this.$forceUpdate();
            },
            // 评论一级评论
            commentRootComment(comment){
                if (!localStorage.getItem('token')) {
                    this.showLoginModal();
                    return;
                }
                if (this.commentContent.trim() != '') {
                    this.submitBtnLoading = true;
                    this.commentForm.content = this.commentContent.trim();
                    this.commentForm.microArticleId = this.microArticleId;
                    this.commentForm.userId = this.$store.state.user.id;
                    this.commentForm.parentCommentId = comment.commentId;
                    let url = config.baseUrl + "microArticleComment/saveComment";
                    this.$http.post(url, this.commentForm).then(response => {
                        this.submitBtnLoading = false;
                        let data = response.data;
                        if (data.resCode == 0) {
                            this.commentForm.content = '';
                            this.commentContent = '';
                            comment.isShowCommentField = false;
                            if (comment.secondCommentInfoList) {
                                comment.secondCommentInfoList.unshift(data.result);
                            } else {
                                comment.secondCommentInfoList = new Array(data.result);
                            }
                        } else {
                            this.submitBtnLoading = false;
                            this.$Message.error(this.$t('common.fail'));
                        }
                    }, error => {
                        this.submitBtnLoading = false;
                        this.$Message.error(this.$t('common.fail'));
                    });
                } else {
                    this.commentContent = '';
                }
            },
            // 评论二级评论
            commentSecondComment(comment, secondComment){
                if (!localStorage.getItem('token')) {
                    this.showLoginModal();
                    return;
                }
                if (this.commentContent.trim() != '') {
                    this.submitBtnLoading = true;
                    let userName = "<a href='" + config.ip + "#/profile/@" + secondComment.userName + "'  style='color: #41B8BC;'>" + "@" + secondComment.userName + "</a>";
                    this.commentForm.content = userName + " : " + this.commentContent.trim();
                    this.commentForm.microArticleId = this.microArticleId;
                    this.commentForm.userId = this.$store.state.user.id;
                    this.commentForm.parentCommentId = comment.commentId;
                    let url = config.baseUrl + "microArticleComment/saveComment";
                    this.$http.post(url, this.commentForm).then(response => {
                        this.submitBtnLoading = false;
                        let data = response.data;
                        if (data.resCode == 0) {
                            this.commentForm.content = '';
                            this.commentContent = '';
                            secondComment.isShowCommentField = false;
                            if (comment.secondCommentInfoList) {
                                comment.secondCommentInfoList.unshift(data.result);
                            } else {
                                comment.secondCommentInfoList = new Array(data.result);
                            }
                        } else {
                            this.submitBtnLoading = false;
                            this.$Message.error(this.$t('common.fail'));
                        }
                    }, error => {
                        this.submitBtnLoading = false;
                        this.$Message.error(this.$t('common.fail'));
                    });
                } else {
                    this.commentContent = '';
                }
            },
        },
    }
</script>


// WEBPACK FOOTER //
// MicroArticle.vue?3da445a2